"use client";

import { useQuery } from "@apollo/client";
import OpenSeadragon from "openseadragon";
import React, { useEffect, useRef, useState } from "react";
import { ACTIVE_WALLHALLA_MANIFEST_QUERY } from "../../graphql/queries/wallhallaQueries";

const WallhallaViewer: React.FC = () => {
    const viewerRef = useRef<HTMLDivElement>(null);
    const [manifest, setManifest] = useState<any>(null);

    const { data } = useQuery(ACTIVE_WALLHALLA_MANIFEST_QUERY);

    useEffect(() => {
        const manifestUrl = data?.activeWallhallaManifest?.manifestUrl;
        if (!manifestUrl) return;

        fetch(manifestUrl)
            .then((res) => res.json())
            .then(setManifest)
            .catch((err) => console.error("Failed to load manifest:", err));
    }, [data]);

    useEffect(() => {
        if (!viewerRef.current || !manifest) return;

        const viewer = OpenSeadragon({
            element: viewerRef.current,
            prefixUrl:
                "https://cdnjs.cloudflare.com/ajax/libs/openseadragon/4.1.0/images/",
            showNavigator: true,
            defaultZoomLevel: 0, // start zoomed out
            minZoomLevel: 0.1, // allow zooming far out
            maxZoomPixelRatio: 10,
            visibilityRatio: 1.0,
            showZoomControl: false,
            showHomeControl: false,
            showFullPageControl: false,
        });

        // Add each strip manually into the same world
        manifest.strips.forEach((strip: any) => {
            viewer.addTiledImage({
                tileSource: strip.dzi,
                x: strip.x / manifest.height, // normalize against height (since world units are relative)
                y: 0,
                width: strip.width / manifest.height,
                success: () => {
                    console.debug("Added strip", strip.index);
                },
            });
        });

        // Once all strips are in, fit bounds to the entire stitched wall
        viewer.addHandler("open", () => {
            viewer.viewport.goHome(true);
        });

        return () => {
            viewer.destroy();
        };
    }, [manifest]);

    return (
        <div>
            <div className="mb-4 flex justify-center">
                <img
                    src="/wallhalla-text.png"
                    alt="Wallhalla"
                    className="mx-auto mt-8 w-1/2"
                />
            </div>
            <div
                ref={viewerRef}
                style={{ width: "100%", height: "80vh" }}
            ></div>
        </div>
    );
};

export default WallhallaViewer;
